import { render } from "./VRivtretto.vue?vue&type=template&id=f18fba30"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VRivtretto.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f18fba30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f18fba30', __exports__)) {
    api.reload('f18fba30', __exports__)
  }
  
  module.hot.accept("./VRivtretto.vue?vue&type=template&id=f18fba30", () => {
    api.rerender('f18fba30', render)
  })

}


export default __exports__